<kendo-skeleton shape="circle" animation="wave" [width]="40" [height]="40"></kendo-skeleton>
<div [ngStyle]="{ flex: '1 1 50%', marginLeft: '16px' }">
  <kendo-skeleton shape="text" animation="wave" width="100%"></kendo-skeleton>
  <kendo-skeleton shape="text" animation="wave" width="40%"></kendo-skeleton>
</div>

<kendo-skeleton shape="rectangle" animation="wave" width="100%" height="143.86px"></kendo-skeleton>
<kendo-skeleton shape="text" animation="wave" width="100%"></kendo-skeleton>
